import request from '@/utils/request'

/**
 *获取地址配置列表
 * @param {*} data 
 */
export function deliveryList(data){
    return request({
        url: '/delivery/list',
        method: 'post',
        data
    })
}

/**
 *地址配置添加
 * @param {*} data 
 */
 export function deliveryAdd(data){
    return request({
        url: '/delivery/add',
        method: 'post',
        data
    })
}

/**
 *地址配置添加
 * @param {*} data 
 */
 export function deliveryUpdate(data){
    return request({
        url: '/delivery/update',
        method: 'post',
        data
    })
}

/**
 *删除分拨点
 * @param {*} data 
 */
 export function deleteDeliverP(data){
    return request({
        url: '/delivery/delete',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/api/delivery.js